import React from 'react';
export const withSSRErrorHandler = (Component, onError) => {
    const SSR = typeof window === 'undefined';
    if (!SSR) {
        return Component;
    }
    return props => {
        try {
            return React.createElement(Component, Object.assign({}, props));
        }
        catch (error) {
            onError(error);
            return null;
        }
    };
};
//# sourceMappingURL=withSSRErrorHandler.js.map